import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { CopyButton, JsonOutput, OutputContainer } from '../../shared/AvatarsOrdering';

interface JsonOutputTabsProps {
    jsonTab: number;
    onTabChange: (newValue: number) => void;
    topAvatarsJson: string;
    avatarsGroupingJson: string;
    onCopy: () => void;
}

export const JsonOutputTabs = ({ jsonTab, onTabChange, topAvatarsJson, avatarsGroupingJson, onCopy }: JsonOutputTabsProps) => {
    return (
        <OutputContainer>
            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                <Tabs value={jsonTab} onChange={(_, newValue) => onTabChange(newValue)}>
                    <Tab label="Top Avatars JSON" />
                    <Tab label="Avatars Grouping JSON" />
                </Tabs>
            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                    <Typography
                        component="a"
                        href={
                            jsonTab === 0
                                ? 'https://app.launchdarkly.com/projects/default/flags/top_avatars/targeting?env=test&selected-env=test'
                                : 'https://app.launchdarkly.com/projects/default/flags/avatars_grouping/variations?env=test&selected-env=test'
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                            color: 'primary.main',
                            textDecoration: 'underline',
                            fontWeight: 600,
                            fontSize: 'inherit',
                            '&:hover': { textDecoration: 'none' },
                        }}>
                        {jsonTab === 0 ? 'top_avatars' : 'avatars_grouping'}
                    </Typography>
                    {' JSON for LaunchDarkly'}
                </Typography>
                <CopyButton onClick={onCopy} size="small" title="Copy to clipboard">
                    <ContentCopyIcon fontSize="small" />
                </CopyButton>
            </Box>

            <JsonOutput>
                {jsonTab === 0 && topAvatarsJson}
                {jsonTab === 1 && avatarsGroupingJson}
            </JsonOutput>
        </OutputContainer>
    );
};
